import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import NavbarFilter from "./NavbarFilter";

const NavbarFilterCampaign = ({
  optionsMenu,
  searchCampaign,
  setSearchCampaign,
}) => {
  return (
    <div className="flex flex-1 lg:gap-x-6 border-b pb-3">
      <NavbarFilter
        formComponents={
          <div className="w-full max-w-sm">
            <InputWithCornerHint
              label="Nombre"
              span=""
              id="searchName" // ID único
              name="searchName"
              type="text"
              className="w-full"
              placeholder="Filtrar por nombre..."
              value={searchCampaign}
              onChange={({ target }) => {
                setSearchCampaign(target.value);
              }}
            />
          </div>
        }
        showPrimaryButton={false}
        toggleDrawer={undefined}
        toggleKpis={undefined}
        optionsMenu={optionsMenu}
        showIcons={false} // Asumo que no necesitas los iconos de exportar, etc. aquí
      />
    </div>
  );
};

export default NavbarFilterCampaign;
